import * as React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation, DialogProps } from '~shared/components/Dialog';
import { Invalidation } from '~teacher/models/quizzes';

export interface Props extends Pick<DialogProps, 'onClose'> {
  open?: boolean;
  invalidation: Invalidation;
}

export function InvalidQuizModal({ open, onClose, invalidation }: Props) {
  return (
    <DialogConfirmation
      id="invalid-quiz"
      open={invalidation != null || open}
      title={invalidation?.title}
      onClose={onClose}
      closeLabel={translate('Close')}
      actions={[
        <UIButton key="primary" appearance="primary" onClick={onClose}>
          {translate('Ok', true)}
        </UIButton>,
      ]}
      data-testid="invalid-modal"
    >
      {invalidation?.meta ? (
        <div className="font-display font-700">{invalidation?.meta}</div>
      ) : null}
      <div>{invalidation?.description}</div>
    </DialogConfirmation>
  );
}
